import { render, staticRenderFns } from "./code-diff.vue?vue&type=template&id=98621f0e&"
import script from "./code-diff.vue?vue&type=script&lang=js&"
export * from "./code-diff.vue?vue&type=script&lang=js&"
import style0 from "./code-diff.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports